import React, { useState, useEffect } from "react";
import { CONFIG } from "../../utils/config";
import { useDearFlip } from "../../hooks/useDearFlip";
import "./PDFModal.css";

interface PDFModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PDFModal: React.FC<PDFModalProps> = ({ isOpen, onClose }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const { isLoaded, isLoading, error, loadDearFlip } = useDearFlip();

  useEffect(() => {
    if (isOpen && !isInitialized) {
      // PDF 플립북 초기화
      const initFlipbook = async () => {
        const container = document.getElementById("flipbook-container");
        if (container && !container.hasAttribute("data-df-initialized")) {
          // DearFlip 로드
          const loadSuccess = await loadDearFlip();
          if (!loadSuccess) {
            console.error('DearFlip 로드 실패:', error);
            return;
          }

          container.innerHTML =
            '<div class="df-book" data-df-book="contents/sample.pdf"></div>';

          // DearFlip 초기화
          if ((window as any).DFBook) {
            (window as any).DFBook.init();
            container.setAttribute("data-df-initialized", "true");
            setIsInitialized(true);
          }
        }
      };

      initFlipbook();
    }

    if (!isOpen && isInitialized) {
      // 모달이 닫힐 때 초기화 상태 리셋
      const container = document.getElementById("flipbook-container");
      if (container) {
        container.innerHTML = "";
        container.removeAttribute("data-df-initialized");
        setIsInitialized(false);
      }
    }
  }, [isOpen, isInitialized]);

  if (!isOpen) return null;

  return (
    <div className="pdf-modal active">
      <div className="pdf-modal-overlay" onClick={onClose}></div>
      <div className="pdf-modal-content">
        <button className="pdf-modal-close" onClick={onClose}>
          &times;
        </button>
        {isLoading && (
          <div className="pdf-loading">
            <div className="loading-spinner"></div>
            <p>PDF 로딩 중...</p>
          </div>
        )}
        {error && (
          <div className="pdf-error">
            <p>PDF 로드에 실패했습니다: {error}</p>
            <button onClick={() => loadDearFlip()}>다시 시도</button>
          </div>
        )}
        <div id="flipbook-container"></div>
      </div>
    </div>
  );
};

export default PDFModal;
